<script setup lang="ts">
const { getTranslation } = useLanguage();

const { main: { journey: { title, cards } } } = getTranslation();
</script>

<template>
  <section>
    <CommonContainer>
      <h2 class="font-semibold leading-default text-4xl 2xs:text-6xl sm:text-7xl hd:text-heading-xl">
        {{ title.base }}
        <span class="text-peach-300">{{ title.keyword }}</span>
      </h2>

      <div class="grid gap-y-8 gap-5 mt-8 xs:mt-12 xs:grid-cols-2">
        <CardsJourneyCard
          v-for="(card, idx) in cards"
          :key="idx"
          v-bind="card"
        />
      </div>
    </CommonContainer>
  </section>
</template>
